import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-crm-sales-pipelines.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Sales Pipeline";

const SalesPipeline = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <figure className={clsx(styles.timelineFigure)}>
          <div className="mx-auto xs:w-2/3 md:w-[150%] md:ml-[-25%]">
            <Image
              src={FigureImage}
              alt="Regardless of which Solar CRM is used, Enerflo Sales Pipeline clearly shows where each solar customer is in the sales process."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
        <TimelineContent
          title={title}
          description="Clearly see where each customer is in the sales process, and easily pick up where you left off to move them forward. Enerflo gives you visibility into all your customer interactions and guides you through what to do within each stage."
          offsetFigure
          icon={
            <Image
              src="/images/icons/sales-pipeline.svg"
              alt="Icon - Enerflo Sales Pipeline"
              layout="responsive"
              height={58}
              width={63}
              quality={100}
              className="crispImage"
            />
          }
        />
      </div>
    </HeroSection>
  </div>
);

export default SalesPipeline;
